import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "../USPSection.module.scss";
import { useState } from "react";
import PropertyDetailsModal from "../../PropertyDetailsModal";
import AccordionV2 from "@Components/Accordian";
import CustomAccordionItem from "./CustomAccordionItem";
import Portal from "@Components/Portal";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
//

const USPStrip = ({ uspData, isPropertyPage = false }: any) => {
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslationHook();

  return (
    <div
      className={isPropertyPage ? styles.containerUspStripPropertyPage : styles.containerUspStrip}
      role="none"
      onClick={() => {
        if (!openModal) setOpenModal(true);
      }}
    >
      {uspData.map((item: any, index: number) => (
        <div data-testid="property-USP" className={styles.inner} key={index}>
          <div
            className={formatClassNames(
              styles.icon,
              item.class_name === "greenBg" && styles.greenBg,
            )}
          >
            {item.leftIcon}
          </div>
          <div className={formatClassNames(styles.titleText, styles[item.titleClass])}>
            {t(item.title)}
          </div>
        </div>
      ))}
      {openModal && (
        <Portal>
          <PropertyDetailsModal
            header={t("propertypage.propertyusp.alwayswithamber")}
            actionButtonText={t("propertypage.components.uspsection.uspstrip.close")}
            hidePropertyModal={(e: Event) => {
              e?.stopPropagation();
              setOpenModal(false);
            }}
          >
            <AccordionV2 data={uspData} CustomAccordionItem={CustomAccordionItem} />
          </PropertyDetailsModal>
        </Portal>
      )}
    </div>
  );
};

export default wrapperHOC(USPStrip, {
  componentName: "USPStrip-PropertyUSPs-PropertyPage",
  showForChina: true,
});
